import React from "react";
import Testimonials from "../../components/services/sections/Testimonials";
import CarouselSlider from "../../components/carousel/CarouselSlider";
import HowItWorks from "../../components/services/sections/HowItWorks";
import Pricing from "../../components/services/sections/Pricing";
import TrustedBy from "../../components/services/sections/TrustedBy";
import StartLearning from "../../components/services/sections/StartLearning";
import WhatWhySections from "../../components/services/sections/WhatWhySections";
import {
  organizationsData,
  trustedByData,
  readyStartData,
} from "../../components/services/data";
const Organizations = () => {
  return (
    <>
      <CarouselSlider />
      <WhatWhySections {...organizationsData} />
      <TrustedBy {...trustedByData} />
      <HowItWorks />
      <Pricing />
      <Testimonials name="organizations" />
      <StartLearning {...readyStartData} />
    </>
  );
};

export default Organizations;
